import { useMutation } from "@tanstack/react-query";
import httpClient from "../httpClient";

export const useDownloadReceiptMutation = ({
  authorisation = "",
  itemId,
}: {
  itemId: string;
  authorisation: string;
}) => {
  return useMutation(
    async () =>
      httpClient(`payment/pay/${itemId}/receipt`, {
        authorisation,
      }).getBlob(),
    {
      onSuccess: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `receipt-${itemId}.pdf`; // nom du fichier
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      onError: (error: any) => {
        console.error("Erreur lors du téléchargement du reçu", error);
      },
    }
  );
};
